<template>
  <div class="form-group">
    <BaseFormField
      :label="label"
      :hide-label="hideLabel"
      :has-tooltip="hasTooltip"
      :tooltip-text="tooltipText"
    >
      <slot
        name="element"
      />
    </BaseFormField>
  </div>
</template>

<script>
import messages from './locales';
import sharedMessages from '@/core/locales';
import BaseFormField from '../Form/BaseFormField';

export default {
  name: 'LabelAndElement',
  components: {BaseFormField},
  props: {
    label: {
      type: String,
      default() { return this.$i18n.t('INPUT_TEXT.LABEL'); } 
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hasTooltip: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default() { return ''; } 
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
};
</script>